import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Text, TextFilters } from "../../types/text";
import EntityTable from "../EntityTable";
import { extractTextEditLink } from "../entitiesReferences/InternalEntityLink";
import { renderRowUpdateAction } from "../../common/TableUtils";
import { MRT_ColumnDef } from "material-react-table";
import useTextQuery from "../../hooks/query/useTextQuery";
import textColumns, { textFilterSpec } from "../../common/entities/TextColumns";
import useServerFilters from "../../hooks/useServerFilters";

interface TextTableProps {
  columns?: MRT_ColumnDef<Text, any>[];
  hiddenColumnIds?: Extract<keyof Text, string>[];
  filters: TextFilters;
  enableRowActions?: boolean;
}

const TextTable: React.FC<TextTableProps> = ({
  columns = textColumns,
  hiddenColumnIds,
  filters,
  enableRowActions = true,
}) => {
  const {
    serverFilters,
    entityTableFilterProps,
    pagination,
    setPagination,
  } = useServerFilters(filters, textFilterSpec);
  const { useFetchAll } = useTextQuery(filters.system_language_type);
  const { data, isLoading, errorMessage } = useFetchAll({
    filters: serverFilters,
    externalPagination: pagination,
    externalSetPagination: setPagination,
  });

  const navigate = useNavigate();

  const renderRowActions = useMemo(
    () =>
      renderRowUpdateAction((text: Text) =>
        navigate(extractTextEditLink(text))
      ),
    [navigate]
  );

  return (
    <EntityTable
      loading={isLoading}
      error={errorMessage}
      columns={columns}
      hiddenColumnIds={hiddenColumnIds}
      renderRowActions={renderRowActions}
      enableRowActions={enableRowActions}
      enableRowSelection={false}
      data={data?.data || []}
      pagination={pagination}
      manualPagination={true}
      onPaginationChange={setPagination}
      totalRowCount={data?.total || 0}
      manualFiltering
      {...entityTableFilterProps}
    />
  );
};

export default TextTable;
